import { render, staticRenderFns } from "./SingleSelectFilterWidget.vue?vue&type=template&id=2fa262b2&scoped=true&"
import script from "./SingleSelectFilterWidget.vue?vue&type=script&lang=js&"
export * from "./SingleSelectFilterWidget.vue?vue&type=script&lang=js&"
import style0 from "./SingleSelectFilterWidget.vue?vue&type=style&index=0&id=2fa262b2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fa262b2",
  null
  
)

export default component.exports